import axios from "const/axios";
import publicAxios from "axios";
import { API_URL_PUBLIC } from "const/constants";

const BASE = "/client-intake-form";

export const getIntakeFormTemplate = async () => {
  const res = await axios.get(`${BASE}/template`);
  return res?.data?.data;
};

export const saveIntakeFormTemplate = async (template) => {
  const res = await axios.put(`${BASE}/template`, template);
  return res?.data?.data;
};

export const sendIntakeFormToClient = async (clientId, note = "") => {
  const res = await axios.post(`${BASE}/send/${clientId}`, { note });
  return res?.data;
};

export const getIntakeFormResponsesForClient = async (clientId) => {
  const res = await axios.get(`${BASE}/responses/client/${clientId}`);
  return res?.data?.data ?? [];
};

export const getIntakeFormTokensForClient = async (clientId) => {
  const res = await axios.get(`${BASE}/tokens/client/${clientId}`);
  return res?.data?.data ?? [];
};

export const getAllIntakeFormResponses = async () => {
  const res = await axios.get(`${BASE}/responses`);
  return res?.data?.data ?? [];
};

// Public endpoints (no auth)
export const getPublicIntakeFormInfo = async (token) => {
  const res = await publicAxios.get(`${API_URL_PUBLIC}/public/client-intake/${token}`, {
    headers: { Authorization: null },
  });
  return res?.data?.data;
};

export const submitPublicIntakeForm = async (token, responses) => {
  const res = await publicAxios.post(
    `${API_URL_PUBLIC}/public/client-intake/${token}`,
    { responses },
    { headers: { Authorization: null } }
  );
  return res?.data;
};
